/**
 * 客户管理api
 * date:2022 04 19
 */

import httpRequest from '@/utils/request.js';

/**获取列表接口 */
export const customerList = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/customer/list',
        params: {
            ...params
        }
    });
/**获取客户详细接口 */
export const customerDetail = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/customer/detail',
        params: {
            ...params
        }
    });
/**新增接口 */
export const customerNew = (data, email, mobile, monitorType) => httpRequest.httpPost('/service/customer/new?email=' + email + '&mobile=' + mobile + '&monitorType=' + monitorType, data);
/**仅更新位置信息（address/lat/lng） */
export const customerUpdateLocation = (data) => httpRequest.httpPut('/service/customer/location', data);
/**编辑接口 */
export const customerEdit = (data, email, mobile, monitorType) => httpRequest.httpPut('/service/customer/edit?email=' + email + '&mobile=' + mobile + '&monitorType=' + monitorType, data);
/**激活接口 */
export const customerActive = data => httpRequest.httpPut('/service/customer/active', data);
/**注销接口 */
export const customerCancel = data => httpRequest.httpPut('/service/customer/cancel', data);
/**编辑接口 */
export const customerRemove = data => httpRequest.httpdelete('/service/customer/remove', data);
